import Home from "./views/Home";
import NotAuthorized from "./components/not-authorized";
import PageNotFound from "./components/page-not-found";
import Roles from "./misc/roles";
import TranslationalTeamsIndex from "./views/translationalteams/teams";
import TranslationalTeamAdd from "./views/translationalteams/add";
import TranslationalTeamEdit from "./views/translationalteams/edit";
import TranslationalTeamDetails from "./views/translationalteams/details";
import translationalTeam from "./store/modules/translational-team";

const USER_ROLES = Roles;

export const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    display: "Home",
    meta: {
      roles: [USER_ROLES.all]
    }
  },
  {
    path: "/impersonation/:asuriteId",
    name: "impersonation",
    component: Home,
    props: true,
    display: "Impersonation",
    meta: {
      roles: [USER_ROLES.impersonation]
    }
  },
  {
    path: "/stopimpersonation",
    name: "stopimpersonation",
    component: Home,
    props: true,
    display: "StopImpersonation"
  },
  {
    path: "/not-authorized",
    name: "notAuthorized",
    component: NotAuthorized,
    display: "Not Authorized"
  },

  {
    path: "/translational-teams",
    name: "translationalTeams",
    component: TranslationalTeamsIndex,
    display: "Translational Teams",
    meta: {
      // roles: [USER_ROLES.translationalTeam]
      roles: [USER_ROLES.translationalTeamAdmin, USER_ROLES.translationalTeamManager, USER_ROLES.translationalTeamViewer]
    }
  },
  {
    path: "/translational-teams/add",
    name: "translationalTeamAdd",
    component: TranslationalTeamAdd,
    display: "Add",
    meta: {
      // roles: [USER_ROLES.translationalTeam]
      roles: [USER_ROLES.translationalTeamManager, USER_ROLES.translationalTeamAdmin]    
    }
  },
  {
    path: "/translational-teams/edit/:translationalTeamId",
    name: "translationalTeamEdit",
    component: TranslationalTeamEdit,
    props: true,
    display: "Edit",
    meta: {
      // roles: [USER_ROLES.translationalTeam]
      roles: [USER_ROLES.translationalTeamManager, USER_ROLES.translationalTeamAdmin]
    }
  },
  {
    path: "/translational-teams/:translationalTeamId",
    name: "translationalTeam",
    component: TranslationalTeamDetails,
    props: true,
    display: "Translational Team Details",
    meta: {
      // roles: [USER_ROLES.translationalTeam]
      roles: [USER_ROLES.translationalTeamAdmin, USER_ROLES.translationalTeamManager, USER_ROLES.translationalTeamViewer]
    }
  },

  {
    path: "*",
    component: PageNotFound
  }
];
